const MAX_LABEL_LENGTH = 25;
const PRESERVED_SUFFIX_LENGTH = 3;

/**
 * Truncate a label to be at most maxLabelLength characters long
 *
 * If the label is longer than maxLabelLength, return an ellipsized string of length maxLabelLength; otherwise,
 * return the original label.
 *
 * example:
 * ```
 *  truncateToMaxLengthLabel("Plasmid-0X13291", 13, 3)
 * ```
 *
 * will return "Plasmid-0…291"
 */
export default function truncateToMaxLengthLabel(
  label: string,
  maxLabelLength: number = MAX_LABEL_LENGTH,
  preservedSuffixLength: number = PRESERVED_SUFFIX_LENGTH
): string {
  if (label.length > maxLabelLength && maxLabelLength > preservedSuffixLength) {
    const prefix = label.substring(0, maxLabelLength - (preservedSuffixLength + 1));
    const suffix = label.substring(label.length - preservedSuffixLength, label.length);
    return `${prefix}\u2026${suffix}`;
  } else {
    return label;
  }
}
